/** Where to write for a code that lets a sign-in create a Chores Champ account. */
export const CONTACT_EMAIL = 'hjemmehund@gmail.com';
